export default "__VITE_ASSET__Wtt3fNkt__"